








































































































































































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import OtherModelDetails from './OtherModelDetails.vue'
import AttributeDetails from './AttributeDetails.vue'
import SalesTeamDetails from '~/components/sales_map_v3/SalesTeamDetails.vue'
import PlanDetailRange from '~/components/sales_map_v3/PlanDetailRange.vue'
import DirectionsMap from '~/components/consumer_map/DirectionsMap.vue'
import VirtualTourWrapper from '~/components/shared/VirtualTourWrapper.vue'
import ImagesGallery from '~/components/shared/imagesGallery.vue'
import LotInfo, { Schedule } from '~/models/lotInfo'
import { PublicProject } from '~/models/project'
import Plan from '~/models/plan'
import Lot from '~/models/lot'
import { FloorPlanImage } from '~/models/elevation'
import projectConfig from '~/assets/project-config.json'
import {
  streetViewMetadata,
  EMBED_BASE_URL,
  STREET_VIEW,
} from '~/api/gmaps.api'
import { LotTypes } from '~/enums/lots'
import globalStyling from '~/mixins/globalStyling'
import LotUtilsMixin from '~/mixins/LotUtilsMixin'
import { Elevation } from '~/models'
import { hasHTMLCode } from '~/utils/htmlDetection'
import 'swiper/css/swiper.css'

@Component({
  components: {
    Swiper,
    SwiperSlide,
    VirtualTourWrapper,
    DirectionsMap,
    ImagesGallery,
    OtherModelDetails,
    SalesTeamDetails,
    PlanDetailRange,
    AttributeDetails,
  },
  mixins: [globalStyling, LotUtilsMixin],
})
export default class HomeSidePanel extends mixins(
  globalStyling,
  LotUtilsMixin
) {
  @Prop({ default: null }) lotInfo: LotInfo
  @Prop({ default: null }) project: PublicProject
  @Prop({ default: null }) model: Lot
  @Prop({ default: null }) filters: any

  showVirtualTour: boolean = false
  currentSlideImage: number = 1
  streetViewMeta = { status: 'ZERO_RESULTS' }
  lotType: string = LotTypes.HOME
  elevations: Array<Elevation> = []
  resizeWindowListener: any = null
  viewHeight: number = 400

  created() {
    this.lotType = this.getLotType(this.project, this.lotInfo)
  }

  async mounted(): Promise<void> {
    await this.getStreetViewMetadata(this.lotInfo)
    this.enableGoogleMap()

    this.resizeWindowListener = window.addEventListener(
      'resize',
      this.setWindowSize
    )
    this.setWindowSize()
  }

  unmounted(): void {
    window.removeEventListener('resize', this.resizeWindowListener)
  }

  get displayAttributes() {
    return (
      this.getStyleVariableValue('--ad-sp-display-attributes')?.replace(
        /['"]+/g,
        ''
      ) === 'true'
    )
  }

  get gallery(): Array<string> {
    return !this.isHomeSite
      ? this.lotInfo.gallery
      : [this.lotInfo.homesite_photo]
  }

  get floorPlanGallery(): Array<FloorPlanImage> {
    if (this.lotInfo.architectural_submission) {
      const floor_plan_images =
        this.lotInfo.architectural_submission?.master_plan?.plan
          ?.floor_plan_images

      if (!floor_plan_images) return []

      return floor_plan_images
        .filter((floorPlan: any) => floorPlan?.source)
        .map((fp: any) => fp.source)
    } else {
      return []
    }
  }

  get isReserved(): boolean {
    return this.lotType === LotTypes.RESERVED
  }

  get isHome(): boolean {
    return this.lotType === LotTypes.HOME
  }

  get isHomeSite(): boolean {
    return this.lotType === LotTypes.HOME_SITE
  }

  get cssVariablePrefix(): string {
    return this.lotType === LotTypes.HOME_SITE ? '--ad-sp-hs-' : '--ad-sp-h-'
  }

  get acreage(): string {
    return this.lotInfo.acreage || '-'
  }

  setWindowSize() {
    if (window.visualViewport) {
      this.viewHeight = window.visualViewport.height - 200
    } else {
      this.viewHeight = window.innerHeight - 200
    }
  }

  getPropertyName(fieldName: string): string {
    return `${this.cssVariablePrefix}${fieldName.split(' ').join('-')}`
  }

  private async getStreetViewMetadata(lotInfo: LotInfo) {
    this.streetViewMeta = await streetViewMetadata(
      lotInfo.latitude,
      lotInfo.longitude,
      process.env.mapApiKey
    )
  }

  get availableDateFormatted(): string {
    let output: string = ''
    const arch = this.lotInfo.architectural_submission
    const availableDate = arch ? arch.available_on : undefined

    if (availableDate) {
      output = this.$dateFns.format(
        new Date(
          `${
            this.lotInfo.architectural_submission
              ? this.lotInfo.architectural_submission.available_on
              : ''
          }T00:00:00`
        ),
        'MMM dd, yyyy'
      )
    } else {
      output = 'Call for Availability'
    }

    return output
  }

  get plan(): Plan {
    return this.lotInfo.architectural_submission?.master_plan?.plan
  }

  get builderImg() {
    return this.lotInfo.builder.logo || this.project.logo
  }

  get overview() {
    if (this.lotType === LotTypes.HOME_SITE)
      return this.lotInfo.description || ''

    return (
      this.lotInfo.architectural_submission?.master_plan?.plan?.description ||
      ''
    )
  }

  get schedule() {
    return this.lotInfo.schedule.map((schedule: Schedule) =>
      Object.entries({
        'Mon - Fri':
          schedule.monday ||
          schedule.tuesday ||
          schedule.wednesday ||
          schedule.thursday ||
          schedule.friday,
        Saturday: schedule.saturday,
        Sunday: schedule.sunday,
      })
    )
  }

  get customPriceLabel(): string {
    if (this.lotInfo?.property_type === 'Condo') {
      const label = projectConfig[this.$route.params.slug]?.condoPriceLabel
      if (label) return label
    }
    if (this.lotType === LotTypes.HOME_SITE)
      return (
        projectConfig[this.project.slug]?.homesitePriceLabel || 'Starting Price'
      )

    return projectConfig[this.project.slug]?.homePriceLabel || 'Listing Price'
  }

  get virtualTourTitle(): string {
    const label = this.getStyleVariableValue(
      '--cm-h-sp-3d-tour-label'
    )?.replace(/['"]+/g, '')

    return label || '3D Tour'
  }

  get virtualTour(): string {
    return (
      this.lotInfo?.architectural_submission?.master_plan?.plan
        ?.virtual_tour_url || null
    )
  }

  get descriptionHeader() {
    const isDescriptionPrimary = this.isVisible(
      '--ad-sp-description-primary-heading'
    )
    return isDescriptionPrimary
      ? 'sm:text-xl font-brand-primary text-brand-base-300 font-bold'
      : 'text-justify font-light font-brand-primary text-brand-base text-base'
  }

  get descriptionText() {
    const isDescriptionPrimary = this.isVisible(
      '--ad-sp-description-primary-heading'
    )
    return isDescriptionPrimary
      ? 'text-sm text-left font-brand-secondary text-brand-base'
      : 'mt-2 font-brand-secondary text-brand-base'
  }

  setShowVirtualTour(value: boolean): void {
    this.showVirtualTour = value
  }

  get gStreetMapUrl(): string {
    return `${EMBED_BASE_URL}${STREET_VIEW}?key=${process.env.mapApiKey}&location=${this.lotInfo.latitude},${this.lotInfo.longitude}&heading=236`
  }

  enableGoogleMap() {
    const googleStreetMap = document.querySelector(
      '#google-street-container'
    ) as Element

    googleStreetMap.querySelector('iframe').style.pointerEvents = 'none'

    googleStreetMap.addEventListener('click', () => {
      googleStreetMap.querySelector('iframe').style.pointerEvents = 'auto'
    })

    googleStreetMap.addEventListener('mouseleave', () => {
      googleStreetMap.querySelector('iframe').style.pointerEvents = 'none'
    })
  }

  lotPrice(lotInfo: any, lotType: string) {
    const price = this.price(lotInfo, lotType)
    const callForDetailsLabel =
      projectConfig[this.$route.params.slug]?.callForDetailsLabel || ''
    if (price.toLowerCase() === 'Call for Details'.toLowerCase()) {
      return callForDetailsLabel || price
    }
    return price
  }

  hasHTMLCode(value: string): boolean {
    return hasHTMLCode(value)
  }
}
